module.exports = __webpack_public_path__ + "static/media/arrowTop.1cb03cbc.svg";